export default "__VITE_ASSET__DP6sjivC__"